<template>
    <div class="backgroud-white cs-courseSchedule-editor">
        <div class="text-center">
            <h4>{{ isAdded?'添加广告': '编辑广告'}}</h4>
        </div>
        <div class="backgroud-gray-popup popup-content-area-small">
            <el-form ref="model" :rules="rules" :model="model" label-width="100px">
                <!-- <el-form-item label="图片" prop="pictureUrl">
                    <el-input @change='checkAllInputs' placeholder="图片Url" v-model="model.pictureUrl" class="input-width"></el-input>
                </el-form-item> -->
                <el-form-item label="连接地址" prop="linkUrl">
                    <el-input @change='checkAllInputs' placeholder="图片链接地址" v-model="model.linkUrl" class="input-width" ></el-input>
                </el-form-item>    
                <el-form-item label="是否可以用" prop="isActive">
                   <el-checkbox  name="type" v-model="model.isActive"></el-checkbox>
                  </el-form-item> 
                   <el-form-item label="广告图片">
                   <el-button type="text" size="medium" @click="uploadAdvertistingImage()">点击上传广告图片</el-button>
        </el-form-item>     
        <el-form-item>
          <image-show           
            :src="advertistingImageSrc"
            :isVisible="advertistingImageShowerVisible"          
          ></image-show>
        </el-form-item>  
        <template>
          <el-dialog
            center
            title="上传广告图片"
            :show-close="true"
            :close-on-click-modal="false"
            width="700px"
            :visible.sync="advertistingImageUploaderVisible"
            top="8vh"
            z-index="2000"
          >
            <blob-uploader
              @closeEditor="onCloseAdvertistingImageUploader"
              @blobUploadError="onScoreUploadError"
              @blobUploaded="onAdvertistingImageUploaded"
              :type="5"
              :accepts="'.png,.jpg,.jpeg'"
              :isVisible="advertistingImageUploaderVisible"
              :isAutoSave="true"
            ></blob-uploader>
          </el-dialog>
        </template>                        
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer popup-footer">
            <el-row>
                <el-col :span="20" class="footer-left">
                    <span v-if="!showError"></span>
                    <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
                </el-col>
                <el-col class="footer-right" :span="4">
                    <el-button :disabled="submitBtnDisable" :type="submitBtnClass" @click="save()">{{ isAdded?'确认添加': '保存更新'}}</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import { add,edit } from "../../service/advertisting.service";
import blobUploader from "@/components/fileHandler/blobUploader";
import imageShow from "@/components/fileHandler/imageShow";
export default {
  props: {
    data: {},
    dialogVisible: false
  },
  data() {
      let urlValidator = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("请输入广告链接URL"));
        }
        let regexp = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        if (regexp.test(value)) {
          return callback();
        }
        return callback(new Error("请输入正确的URL"));
      };
    return {
      model: {
        pictureUrl: "",
        linkUrl: "",       
        isActive: false
      },
      submitBtnClass: "info",
      submitBtnDisable: true,
      submitBtnStatus: {
        status: true,
        stopTime: null,
        resetStatus: function() {
          let self = this;
          clearTimeout(self.stopTime);
          self.stopTime = setTimeout(() => {
            self.status = true;
          }, 1500);
        }
      },
      isAdded: false,     
      showError: false,     
      errorMessage: "",
      rules: {
        // pictureUrl: [
        //   {
        //     required: true,
        //     message: "请输入图片Url",
        //     trigger: "blur"
        //   }         
        // ],
        linkUrl: [
          {
            required: true,
            message:"请输入连接图片",
            trigger: "blur"
          },
          {
            validator: urlValidator,
            trigger: "blur"
          }
        ]       
      },
      advertistingImageUploaderVisible: false,
      advertistingImageShowerVisible: false,
      advertistingImageSrc: ""
    };
  },
  components: {  
     blobUploader,
     imageShow
  },
  created() {
    this.loadData();
  },
  methods: {
    checkAllInputs(value, onlyCheck) {
      let isValid = true;

      if (!this.$refs["model"]) return false;

      this.$refs["model"].validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });

      if (onlyCheck) return isValid;

      this.submitBtnClass = isValid ? "primary" : "info";
      this.submitBtnDisable = !isValid;

      return isValid;
    },
    save() {
      if (this.submitBtnStatus.status) {
        this.submitBtnStatus.status = false;

        let isValid = this.checkAllInputs(null, true);
        if (!isValid) return false;

        this.submitBtnDisable = true;
        if(this.isAdded){
        let result = add(
          this.model
        ).then(result => {
          if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
          } else {
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.showError = false;
            this.$emit("saveSuccess", this.isAdded, result.data);
            this.close();
          }
          this.submitBtnDisable = false;
        });
        }else{
           let result = edit(
          this.model
        ).then(result => {
          if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
          } else {
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.showError = false;
            this.$emit("saveSuccess", this.isAdded, result.data);
            this.close();
          }
          this.submitBtnDisable = false;
        });
        }
      }

      this.submitBtnStatus.resetStatus();
    },
    close() {
      //this.$refs["model"].resetFields();
      this.$emit("closeDialog");
    },
    loadData() { 
      if (!!this.data && !!this.data.id) {
        this.isAdded = false;
        this.model.id = this.data.id;       
        this.model.pictureUrl = this.data.pictureUrl;
        this.model.isActive = this.data.isActive;
        this.model.linkUrl = this.data.linkUrl;
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;     
        this.advertistingImageSrc=this.data.pictureUrl;
        this.advertistingImageShowerVisible =true;      
      } else {
        this.isAdded = true;
        this.model.id = "";       
        this.model.pictureUrl = "";
        this.model.isActive = true;
        this.model.linkUrl = ""; 
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
        this.advertistingImageSrc="";  
        this.advertistingImageShowerVisible =false;        
      }
    },
    uploadAdvertistingImage() {
      this.advertistingImageUploaderVisible = true;
    },
    onCloseAdvertistingImageUploader() {
      this.closeAdvertistingImageUploader();
    },
    onScoreUploadError() {},
    closeAdvertistingImageUploader() {
      this.advertistingImageUploaderVisible = false;
    },
    onAdvertistingImageUploaded(data) {
      if (!!data) {
        this.model.pictureUrl = data.Path;
       // this.model.fileId = data.fileId;
        this.advertistingImageSrc= data.Path; 
        this.advertistingImageShowerVisible =true;
        this.closeAdvertistingImageUploader();
         }
    } 
  },
  watch: {
    data: function() {
      this.loadData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/advertistings/adEdit.vue